/**
 * @author caijianjia
 * @date 2020/4/14 1:59 下午
 */
//import {getIndexByAttr} from '../../../../../../../../../../utils/utils'
const normal = [
    {
        attr: 'categoryId',
        "name": "目录选择",
        "value": [],
        "type": "Cascader",
        "props": {
            style: 'width: 180px',
            "placeholder": "请选择",
            "rules": {
                "required": false,
                "message": "请选择"
            }
        },
        "options": []
    },
    {
        attr: 'name',
        name: '素材名称',
        value: '',
        type: 'Input',
        props: {
            placeholder: '请输入',
            rules: {
                required: true,
                message: '请输入',
                target: 'blur'
            }
        }
    },
    {
        attr: 'alias',
        name: '中文名称',
        value: '',
        type: 'Input',
        props: {
            placeholder: '请输入',
            rules: {
                required: false,
                message: '请输入',
                target: 'blur'
            }
        }
    },
    /*{
        attr: 'url',
        "name": '上传文件',
        "value": "",
        "type": "UploadSingleTencent",
        "props": {
            "rules": {
                "required": true,
                "message": "请选择",
                "target": "blur"
            }
        },
        "status": "1",
        isPlat: false
    }*/
]
const scenesConfig = [
    {
        attr: 'categoryId',
        "name": "目录选择",
        "value": [],
        "type": "Cascader",
        "props": {
            "placeholder": "请选择",
            "rules": {
                "required": false,
                "message": "请选择"
            }
        },
        "options": []
    },
    {
        attr: 'scenes_stage_id',
        name: '选择导航',
        value: '',
        type: 'Select',
        props: {
            placeholder: '请输入',
            rules: {
                required: true,
                message: '请输入',
                target: 'blur'
            }
        },
        options: []
    },
    {
        attr: 'name',
        name: '场景名称',
        value: '',
        type: 'Input',
        props: {
            placeholder: '请输入',
            rules: {
                required: true,
                message: '请输入',
                target: 'blur'
            }
        }
    },
    {
        attr: 'cover',
        name: '场景图片',
        value: '',
        type: 'UploadSingleTencent',
        props: {
            accept: '.png,.jpeg,.jpg',
            placeholder: '请选择',
            rules: {
                required: false,
                message: '请选择',
                target: 'blur'
            }
        }
    },
    {
        attr: 'options',
        name: '默认场景配置',
        value: [{ url: '' }],
        type: 'UploadMulTencent',
        props: {
            accept: '.png,.jpeg,.jpg',
            placeholder: '选择',
            rules: {
                required: false,
                message: '请选择'
            }
        }
    }
]
const animationConfig = [
    {
        attr: 'categoryId',
        "name": "目录选择",
        "value": [],
        "type": "Cascader",
        "props": {
            "placeholder": "请选择",
            "rules": {
                "required": false,
                "message": "请选择"
            }
        },
        "options": []
    },
    {
        attr: 'type',
        name: '动画分类',
        value: '',
        type: 'Select',
        props: {
            placeholder: '请选择',
            rules: {
                required: true,
                message: '请选择'
            }
        },
        options: [
            { key: 'flash', value: 'flash' },
            { key: 'keel', value: '龙骨动画' },
            { key: 'cocos', value: 'cocos动画' },
        ]
    },
    {
        attr: 'name',
        name: '动画名称',
        value: '',
        type: 'Input',
        props: {
            placeholder: '请输入',
            rules: {
                required: true,
                message: '请输入',
                target: 'blur'
            }
        }
    },
    {
        attr: 'alias',
        name: '动画中文名称',
        value: '',
        type: 'Input',
        props: {
            placeholder: '请输入',
            rules: {
                required: false,
                message: '请输入',
                target: 'blur'
            }
        }
    },
    {
        attr: 'remotepath',
        name: '动画包',
        value: '',
        type: 'UploadSingleTencent',
        props: {
            accept: '.zip',
            placeholder: '请选择',
            rules: {
                required: true,
                message: '请选择',
                target: 'blur'
            }
        },
        isBackObj: true
    },
    {
        attr: 'remotepath_view',
        name: '动画预览包',
        value: '',
        type: 'UploadSingleTencent',
        props: {
            accept: '.html',
            placeholder: '请选择',
            rules: {
                required: true,
                message: '请选择',
                target: 'blur'
            }
        }
    },
    {
        attr: 'cover',
        "name": '动画图片',
        "value": "",
        "type": "UploadSingleTencent",
        "props": {
            accept: '.png,.jpeg,.jpg',
            "rules": {
                "required": true,
                "message": "请选择",
                "target": "blur"
            }
        },
        "status": "1",
        isPlat: false
    },
    {
        attr: 'background_img',
        name: '背景图片',
        value: '',
        type: 'UploadSingleTencent',
        props: {
            accept: '.png,.jpeg,.jpg',
            rules: {
                required: false,
                message: '请选择',
                target: 'blur'
            }
        },
        status: '1',
        isPlat: false
    },
    {
        attr: 'background_audio',
        name: '背景音乐',
        value: '',
        type: 'UploadSingleTencent',
        props: {
            accept: '.mp3',
            rules: {
                required: false,
                message: '请选择',
                target: 'blur'
            }
        },
        status: '1',
        isPlat: false
    }
]
export function getConfigByType(type) {
    let config = JSON.parse(JSON.stringify(normal))
    console.log(type);
    return config
    /*
    let name = ''
    let accept = ''
    switch (type) {
        case 'image': {
            name = '上传图片'
            accept = '.png,.jpeg,.jpg'
            // TODO 图片上传特殊处理【上传图片组件换成UploadSingleTencent2】
            let urlIndex = getIndexByAttr({attr: 'url', data: config})
            config[urlIndex].type = 'UploadSingleTencent2'
            break
        }
        case 'audio': {
            name = '上传音频'
            accept = '.mp3'
            // TODO 图片上传特殊处理【上传图片组件换成UploadSingleTencent2】
            let urlIndex = getIndexByAttr({attr: 'url', data: config})
            config[urlIndex].type = 'UploadSingleTencent2'
            break
        }
        case 'video': {
            name = '上传视频'
            accept = '.mp4'//,.mov
            // TODO 图片上传特殊处理【上传图片组件换成UploadSingleTencent2】
            let urlIndex = getIndexByAttr({attr: 'url', data: config})
            config[urlIndex].type = 'UploadSingleTencent2'
            break
        }
        default:
    }
    let index = getIndexByAttr({attr: 'url', data: config})
    config[index].name = name
    config[index].props.accept = accept

    return config /**/
}
export const typeEnums = {
    scenes: scenesConfig,
    image: getConfigByType('image'),
    audio: getConfigByType('audio'),
    animation: animationConfig,
    video: getConfigByType('video'),
}
